





















import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class CurriculumVitae extends Vue {
  copy(): void {
    let x = document.getElementById('cv-clone-input')
    if(x)
      x.focus()
    else
      alert('Could not focus')
    document.execCommand('copy')
  }

  get url(): string {
    return this.$t('cv.path').toString()
  }

  get absoluteUrl(): string {
    return new URL(this.url, document.baseURI).href
  }
}
